/**
 * The project the asset routes should treat as the caller's context.
 *
 * `/assets/:id/{url,spec,job}` authorize on the asset's server-recorded owner
 * project; only a legacy asset with NO owner on record (frame extracts and
 * subject crops written before owners were stamped) falls back to a claimed
 * project, and then only when that project's doc lists the asset (SEC-4).
 * Without the claim those legacy assets 403 for their rightful users, so
 * every asset fetch carries the open project as `?projectId=`.
 *
 * Lives in its own module because api.ts cannot import the bootstrap store
 * (the store's dependencies import api.ts). Set by bootstrap when a project
 * opens; null outside a project.
 */
let currentProjectId: string | null = null

export function setAssetProjectContext(projectId: string | null): void {
  currentProjectId = projectId
}

export function getAssetProjectContext(): string | null {
  return currentProjectId
}
